import { phdScannerApiAxios } from "../lib/axios-interceptor";

type PARAMTYPE = Record<string, string | number | boolean>;

export const UniversityApplicantService = {
  // Get applicants for an opportunity
  async getApplicants(params: PARAMTYPE) {
    try {
      const response = await phdScannerApiAxios.get("/api/university/applicants", { params });
      return response.data;
    } catch (error) {
      console.error('Error in getApplicants:', error);
      throw error;
    }
  },

  // Get a specific applicant by ID
  async getApplicantById(id: string) {
    try {
      const response = await phdScannerApiAxios.get(`/api/university/applicants/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error in getApplicantById:', error);
      throw error;
    }
  },

  // Update applicant status
  async updateApplicantStatus(id: string, data: { status: string }) {
    try {
      const response = await phdScannerApiAxios.put(`/api/university/applicants/${id}/status`, data);
      return response.data;
    } catch (error) {
      console.error('Error in updateApplicantStatus:', error);
      throw error;
    }
  },

  // Create a comment for an applicant
  async createComment(applicantId: string, comment: string) {
    try {
      const response = await phdScannerApiAxios.post(`/api/university/applicants/${applicantId}/comments`, { comment });
      return response.data;
    } catch (error) {
      console.error('Error in createComment:', error);
      throw error;
    }
  },

  // Get comments for an applicant
  async getComments(applicantId: string) {
    try {
      const response = await phdScannerApiAxios.get(`/api/university/applicants/${applicantId}/comments`);
      return response.data;
    } catch (error) {
      console.error('Error in getComments:', error);
      throw error;
    }
  },

  // Delete a comment
  async deleteComment(applicantId: string, commentId: string) {
    try {
      const response = await phdScannerApiAxios.delete(`/api/university/applicants/${applicantId}/comments/${commentId}`);
      return response.data;
    } catch (error) {
      console.error('Error in deleteComment:', error);
      throw error;
    }
  },

  // Delete an applicant
  async deleteApplicant(id: string) {
    try {
      const response = await phdScannerApiAxios.delete(`/api/university/applicants/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error in deleteApplicant:', error);
      throw error;
    }
  },

  // Download resume
  async downloadResume(id: string) {
    try {
      const response = await phdScannerApiAxios.get(`/api/university/applicants/${id}/download`);
      return response.data;
    } catch (error) {
      console.error('Error in downloadResume:', error);
      throw error;
    }
  },

  // Get applicant statistics
  async getApplicantStats(params: PARAMTYPE = {}) {
    try {
      const response = await phdScannerApiAxios.get("/api/university/applicants/stats", { params });
      return response.data;
    } catch (error) {
      console.error('Error in getApplicantStats:', error);
      throw error;
    }
  },
};
